import { BASE_URL } from "../../../shared/consts/variables";
import { headerAuthorization } from "../../../shared/helpers/localstorage-helper";
import { SelectOption } from "../../../shared/types/select-options";

export const getCompaniesListSelect = async (): Promise<SelectOption[]> => {
    try {
        const response = await fetch(`${BASE_URL}/companies`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...headerAuthorization(),
            },
        });

        if (!response.ok) {
            throw new Error(`Erro HTTP: ${response.status}`);
        }

        const data = await response.json();
        
        return data.map((company: any) => ({
            id: company.id,
            label: company.name || company.description,
        }));
    } catch (error) {
        console.error('❌ Erro ao buscar empresas:', error);
        throw error;
    }
}